import React from "react";
import { Outlet } from "react-router-dom";

const PcmoduleLayout=()=>{
  return (
    <div>
      <h3>PC모듈 통합관리</h3>
      <Outlet />
    </div>
  );
}

export default PcmoduleLayout;